import { PrintOptions } from '../../../output/report/report-job'

export enum WorkSegmentCommand {
  /**
   * Process the work segment(s)
   */
  PROCESS = 'PROCESS',

  /**
   * PROVIDE item labels of the work segment(s)
   */
  PROVIDE_ITEM_LABELS = 'PROVIDE_ITEM_LABELS',

  /**
   * TRANSFER the work segment(s)
   */
  TRANSFER = 'TRANSFER',

  /**
   * Complete the work segment(s)
   */
  COMPLETE = 'COMPLETE',

  /**
   * Re-calculate and update the production groups of the segment(s).
   */
  REFRESH_PROD_GROUPS = 'REFRESH_PROD_GROUPS',
}

export class NewBatchSegmentJob {
  constructor(
    public workBatchId: string,
    public workStationId: string,
    public workCenterId: string,
    public command: WorkSegmentCommand,
    public options?: WorkSegmentCommandOptions
  ) {}
}

export class WorkSegmentCommandOptions {
  public static Print(printerId: string): WorkSegmentCommandOptions {
    return new WorkSegmentCommandOptions(PrintOptions.printer(printerId))
  }

  constructor(public printOptions: PrintOptions) {}
}

export class BatchJob {
  constructor(
    public workBatchId: string,
    public workStationId: string,
    public workCenterId: string,
    public command: WorkSegmentCommand,
    public result: BatchJobResult
  ) {}
}

export class BatchJobResult {
  constructor(
    public affectedItems: number,
    public outputJobId: string
  ) {}
}
